import i18next from 'i18next'
import { STORE_ITEM_TRANSACTION_TYPE } from '../../../utils/enums'

export default (values: any, props: any) => {
	const errors: any = {}

	if (!values.amount) {
		errors.amount = i18next.t('state:Toto pole je povinné')
	}

	const type = values?.type || STORE_ITEM_TRANSACTION_TYPE.REGULAR

	/**
	 * Mód "Pripísať cez sklad" - odosielateľ sa nevypĺňa, namiesto neho je povinný virtuálny sklad
	 * a cieľom je zamknutá zákazka. Mód drží modál, redux-form ho posiela vo `props`.
	 */
	if (props?.isViaStoreMode && type === STORE_ITEM_TRANSACTION_TYPE.IN) {
		if (!values.viaJobID) {
			errors.viaJobID = i18next.t('state:Toto pole je povinné')
		}

		if (!values.jobToID) {
			errors.jobToID = i18next.t('state:Toto pole je povinné')
		}

		if (values.viaJobID && values.viaJobID === values.jobToID) {
			errors.viaJobID = i18next.t('state:Odosielateľ a príjemca nemôžu byť rovnaký sklad')
		}

		// pri presune z existujúcich zásob musí sklad naozaj mať dosť kusov
		if (values.useExistingStock && values.viaJobID && (values.viaStoreStock || 0) < values.amount) {
			errors.viaJobID = i18next.t('state:Na sklade nie je dostatok zásob')
		}

		return errors
	}

	// "Pripísať" nemá odosielateľa, "Odpísať" nemá príjemcu - ostatné adresy sú povinné
	if (type !== STORE_ITEM_TRANSACTION_TYPE.IN && !values.jobFromID) {
		errors.jobFromID = i18next.t('state:Toto pole je povinné')
	}

	if (type !== STORE_ITEM_TRANSACTION_TYPE.CONSUME && !values.jobToID) {
		errors.jobToID = i18next.t('state:Toto pole je povinné')
	}

	if (type === STORE_ITEM_TRANSACTION_TYPE.REGULAR && values.jobFromID && values.jobFromID === values.jobToID) {
		errors.jobToID = i18next.t('state:Odosielateľ a príjemca nemôžu byť rovnaký sklad')
	}

	return errors
}
